module.exports = __webpack_public_path__ + "static/img/jx-logo.a5aa85d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx-logo.jpg
// module id = KKjL
// module chunks = 16